
import { Vue, Component, Prop, Watch, Ref } from "vue-property-decorator";
import { PrintData } from "../definitions";
import axios from "axios";
import {
  download,
  getFilenameFromContentDispositionHeader,
  dateTimeFormat,
} from "@/utils";
import { Table } from "element-ui";

import JSZip from "jszip";
import FileSaver from "file-saver";
import { PDFDocument, PDFPage } from "pdf-lib";
import cloneDeep from "lodash/cloneDeep";
interface PrintItem extends PrintData {
  printPage?: number;
}
type DowloadType = "全部" | "箱唛" | "调拨面单";
type DowloadCommand = "batchPrintToZip" | "batchPrintMergePDF";
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error.response) {
      console.log("Please check your internet connection.");
    }

    return Promise.reject(error);
  }
);

const getFile = (url = ""): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url,
      responseType: "arraybuffer",
    })
      .then((data) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error.toString());
      });
  });
};

@Component
export default class wmsPrintPdfPrint extends Vue {
  @Prop({ required: true }) data!: PrintData[];
  // @Prop({
  //   required: true,
  //   default: [
  //     {
  //       label: "[调拨面单]PPL-20240326-612389/FBOX-240326-00009",
  //       url: "http://gzfastdfs.banggood.cn/fast/download?fileUrl=2024-03-27/eb4e30c9-e8af-4252-baaf-33bdde28dd71.pdf",
  //     },
  //     {
  //       label: "[调拨面单]PPL-20240326-612388/FBOX-240326-00010",
  //       url: "http://gzfastdfs.banggood.cn/fast/download?fileUrl=2024-03-28/42859ce8-e0d5-44b1-a1c3-d7185c6c5851.pdf",
  //     },
  //     {
  //       label: "[调拨面单]PPL-20240326-612390/FBOX-240326-00006",
  //       url: "http://gzfastdfs.banggood.cn/fast/download?fileUrl=2024-03-27/5abcb046-a80e-4b05-8fa7-0bd9e909ffb0.pdf",
  //     },
  //     {
  //       label: "[调拨面单]PPL-20240326-612390/FBOX-240326-00007",
  //       url: "http://gzfastdfs.banggood.cn/fast/download?fileUrl=2024-03-27/8488f180-d4d4-4bfe-8205-9d1e9e32752b.pdf",
  //     },
  //     {
  //       label: "[调拨面单]PPL-20240326-612390/FBOX-240326-00008",
  //       url: "http://gzfastdfs.banggood.cn/fast/download?fileUrl=2024-03-27/98ce5e24-e7b8-4e48-ad12-169818810bb0.pdf",
  //     },
  //   ],
  // })
  // data!: [];
  /** 打印key */
  @Prop() businessKey!: string;
  @Ref("table") table!: Table;
  printItemList: PrintItem[] = [];
  selection: PrintItem[] = [];
  printerOptions: string[] = [];
  selectedPrinter = "";
  printerReady = false;
  initializingPrinter = false;
  printConfig: { [businessKey: string]: string } = {};
  savingConfig = false;
  printing = false;
  dowloadTypePickerDialogState = {
    downloadType: "全部" as DowloadType,
    command: "batchPrintToZip" as DowloadCommand,
    visible: false,
  };
  downloadDialogState = {
    title: "",
    visible: false,
    total: 0,
    finished: 0,
  };
  @Watch("data", { immediate: true })
  handleDataChange(val: PrintData[]) {
    if (Array.isArray(val)) {
      this.printItemList = this.genPrintItemList(val);
      this.selection = this.printItemList;
      this.$nextTick(() => {
        this.printItemList.forEach((item) => {
          this.table.toggleRowSelection(item, true);
        });
      });
    }
  }
  mounted() {
    // 初始化打印机选择
    this.initPrinterList();
  }
  genPrintItemList(data: PrintData[]) {
    return data.map((ele) => ({
      ...ele,
      printPage: 1,
    }));
  }
  handleSelectionChange(val: PrintData[]) {
    this.selection = val;
  }
  async initPrinterList() {
    this.initializingPrinter = true;
    const res = await axios
      .get("http://127.0.0.1:6789/api/Printer")
      .catch((err) => {
        this.printerReady = false;
        this.initializingPrinter = false;
        return err;
      });
    if (res.data && res.data.success && Array.isArray(res.data.result)) {
      this.printerOptions = res.data.result;
      this.printerReady = true;
    } else {
      this.printerReady = false;
    }
    const configRes = await axios.get("http://127.0.0.1:6789/api/Config");
    if (
      this.businessKey &&
      configRes.data.success &&
      configRes.data.result &&
      typeof configRes.data.result === "object"
    ) {
      this.printConfig = configRes.data.result;
      const printer = configRes.data.result[this.businessKey];
      if (printer && this.printerOptions.some((ele) => ele === printer)) {
        this.selectedPrinter = printer;
      }
    }
    this.initializingPrinter = false;
  }
  async testIsInstalled() {
    const ready = this.printerReady;
    if (!ready) {
      this.$emit("lostInstalled");
    }
    return ready;
  }
  async handlePrinterChange(val: string) {
    if (!val) {
      return;
    }
    if (this.businessKey) {
      const config = {
        ...this.printConfig,
        [this.businessKey]: val,
      };

      const res = await axios.post(
        `http://127.0.0.1:6789/api/Config?config=${JSON.stringify(config)}`
      );
      const success = res.data.success;
      if (!success) {
        this.$message.error("保存打印配置失败，请重新选择打印机!");
        this.selectedPrinter = "";
      }
    }
  }
  testPrinterReady() {
    if (!this.selectedPrinter) {
      this.$message.warning("请选择打印机");
      return false;
    }
    if (this.initializingPrinter) {
      this.$message.warning("正在加载打印机，请稍后");
      return false;
    }
    if (this.printing) {
      this.$message.warning("正在打印中，请稍后");
      return false;
    }
    return true;
  }
  getRowPrintDataList(row: PrintItem): PrintItem[] {
    const list: PrintItem[] = [];
    const quantity = row.printPage || 1;
    for (let i = 0; i < quantity; i++) {
      list.push(row);
    }
    return list;
  }
  async batchPrint() {
    const installed = await this.testIsInstalled();
    if (!installed) {
      return;
    }
    if (!this.testPrinterReady()) {
      return;
    }
    if (this.selection.length === 0) {
      this.$message.warning("请选择打印文件");
      return;
    }
    this.printing = true;
    const res = await axios.post(
      `http://127.0.0.1:6789/api/PrintPdf`,
      this.selection
        .map((ele) => this.getRowPrintDataList(ele))
        .flat()
        .map((ele) => ({
          serviceType: this.businessKey,
          fileUrl: ele.url,
        }))
    );
    this.printing = false;
    if (res.data.success) {
      this.$message.success("已打印");
    }
  }
  async printSingle(row: PrintItem) {
    const installed = await this.testIsInstalled();
    if (!installed) {
      return;
    }
    if (!this.testPrinterReady()) {
      return;
    }
    const printData = this.getRowPrintDataList(row);
    this.printing = true;
    const res = await axios.post(
      `http://127.0.0.1:6789/api/PrintPdf`,
      printData.map((ele) => ({
        serviceType: this.businessKey,
        fileUrl: ele.url,
      }))
    );
    this.printing = false;
    if (res.data.success) {
      this.$message.success("已打印");
    }
  }
  download(row: PrintItem) {
    axios
      .request({
        url: row.url,
        withCredentials: true,
        responseType: "blob",
      })
      .then(async (res) => {
        if (res.data instanceof Blob) {
          const objUrl = await URL.createObjectURL(res.data);
          const filename = getFilenameFromContentDispositionHeader(
            res.headers["content-disposition"]
          );
          download(objUrl, filename);
          setTimeout(() => {
            URL.revokeObjectURL(objUrl);
          });
        } else {
          this.$message.error("下载失败");
        }
      });
  }

  openDowloadTypePickerDialog(command: DowloadCommand) {
    this.dowloadTypePickerDialogState.command = command;
    this.dowloadTypePickerDialogState.downloadType = "全部";
    this.dowloadTypePickerDialogState.visible = true;
  }
  dowloadTypeConfirm() {
    let itemList: PrintItem[] = [];
    const downloadType = this.dowloadTypePickerDialogState.downloadType;
    const selection = cloneDeep(this.selection);
    if (downloadType === "全部") {
      itemList = selection;
    } else if (downloadType === "箱唛") {
      itemList = selection.filter((ele) => ele.label.indexOf("箱唛") >= 0);
    } else if (downloadType === "调拨面单") {
      itemList = selection.filter((ele) => ele.label.indexOf("调拨面单") >= 0);
    }
    if (itemList.length === 0) {
      const msg =
        downloadType == "全部"
          ? "请选择要打印的文件"
          : `选择的文件中未包含${downloadType}`;
      this.$message.warning(msg);
      return;
    }
    const items: PrintItem[] = [];
    itemList.forEach((item) => {
      const quantity = item.printPage as number;
      if (quantity === 1) {
        items.push(item);
      } else {
        for (let i = 0; i < quantity; i++) {
          items.push(item);
        }
      }
    });
    switch (this.dowloadTypePickerDialogState.command) {
      case "batchPrintToZip":
        this.batchPrintToZip(items);
        break;
      case "batchPrintMergePDF":
        this.batchPrintMergePDF(items);
        break;
    }
    this.dowloadTypePickerDialogState.visible = false;
  }
  dowloadTypeCancel() {
    this.dowloadTypePickerDialogState.visible = false;
  }
  /**文件打包
   * fileList:文件list:[{fileUrl:文件url,renameFileName:文件名}]
   * filename 压缩包名
   * */
  batchPrintToZip(selection: PrintItem[]) {
    let zip = new JSZip();
    let promises = [];
    this.downloadDialogState.total = selection.length;
    this.downloadDialogState.finished = 0;
    this.downloadDialogState.title = "批量下载单个PDF";
    this.downloadDialogState.visible = true;
    const fetchFilePromiseWeakMap: WeakMap<
      PrintItem,
      Promise<ArrayBuffer>
    > = new WeakMap();
    const fileNamesCountMap: Map<string, number> = new Map();
    for (let item of selection) {
      let fetchFilePromise = fetchFilePromiseWeakMap.get(item);
      if (!fetchFilePromise) {
        fetchFilePromise = getFile(item.url);
        fetchFilePromiseWeakMap.set(item, fetchFilePromise);
      }
      const promise = fetchFilePromise.then((data) => {
        // 下载文件, 并存成ArrayBuffer对象

        let label = item.label.replace("/", "_");
        const count = fileNamesCountMap.get(label) || 0;
        fileNamesCountMap.set(label, count + 1);
        let fileName = "";
        if (count >= 1) {
          fileName = `${label}(${count + 1}).pdf`; //同名文件加数字
        } else {
          fileName = `${label}.pdf`;
        }
        zip.file(fileName, data, { binary: true }); // 逐个添加文件
        this.downloadDialogState.finished++;
      });
      promises.push(promise);
    }
    const filename = `打印调拨单_批量下载单个PDF${dateTimeFormat(
      new Date(),
      "yyyymmddHHMMSS"
    )}`;
    Promise.all(promises)
      .then(() => {
        const animationDelay = 300;
        zip.generateAsync({ type: "blob" }).then((content) => {
          // 生成二进制流
          FileSaver.saveAs(content, filename);
        });
        setTimeout(() => {
          this.downloadDialogState.visible = false;
        }, animationDelay);
      })
      .catch((err) => {
        this.$message.error("文件压缩失败");
        this.downloadDialogState.visible = false;
      });
  }
  /**
   * 批量下载到同一个PDF文件
   */
  async batchPrintMergePDF(data: PrintItem[]) {
    const mergedPDF = await PDFDocument.create();
    this.downloadDialogState.total = data.length;
    this.downloadDialogState.finished = 0;
    this.downloadDialogState.title = "批量下载合并PDF";
    this.downloadDialogState.visible = true;
    const loadFilePromiseWeakMap: WeakMap<
      PrintItem,
      Promise<PDFDocument>
    > = new WeakMap();
    const promise = data.map(async (ele) => {
      let loadFilePromise = loadFilePromiseWeakMap.get(ele);
      if (!loadFilePromise) {
        loadFilePromise = new Promise((resolve) => {
          (async () => {
            const fileContent = await getFile(ele.url);
            const pdf = await PDFDocument.load(fileContent as ArrayBuffer);
            resolve(pdf);
          })();
        });
        loadFilePromiseWeakMap.set(ele, loadFilePromise);
      }
      const pdf = await loadFilePromise;
      const copiedPages: PDFPage[] = await mergedPDF.copyPages(
        pdf,
        pdf.getPageIndices()
      );
      this.downloadDialogState.finished++;
      return copiedPages;
    });
    const res = await Promise.all(promise);
    res.forEach((copiedPages) => {
      copiedPages.forEach((page) => {
        mergedPDF.addPage(page);
      });
    });
    const fileBase64 = await mergedPDF.saveAsBase64();
    // mergedPDF.flush();
    const downloadLink = document.createElement("a");
    downloadLink.href = "data:application/pdf;base64," + fileBase64;
    downloadLink.download = `打印调拨单_下载合并PDF_${dateTimeFormat(
      new Date(),
      "yyyymmddHHMMSS"
    )}.pdf`;
    downloadLink.click();
    const animationDelay = 300;
    setTimeout(() => {
      this.downloadDialogState.visible = false;
    }, animationDelay);
  }
}
